import { writable } from 'svelte/store';

// Пока идёт цепочка задач сюжетного квеста, обычная карточка задания в худе
// прячется: две панели рядом спорили друг с другом (замечание владельца).
export const lsTasksActive = writable(false);
